export default [
    {
        path: '/teachers/positions/categories',
        name: 'teacher-position-categories',
        component: () => import ('./views/Index.vue'),
        meta: {
            title: 'Categoria de Cargo do Professor',
            icon: 'mdi-shape',
            breadcrumbs: [
                { text: 'Categoria de Cargo do Professor', disabled: true }
            ]
        }
    },
]
